import { createBrowserClient } from '@nokowazzi/supabase-client';
import { env } from '../env';

export const supabase = createBrowserClient({
  url: env.VITE_SUPABASE_URL,
  anonKey: env.VITE_SUPABASE_ANON_KEY,
});
